import {Component, OnInit, Output, EventEmitter} from '@angular/core';
import {
    NgForm,
    FormGroup,
    FormControl,
    FormArray,
    Validators,
    ValidatorFn,
    AsyncValidatorFn
} from '@angular/forms';
import {ActivatedRoute} from '@angular/router';
import {MessageComponent, BaseComponent} from '../common/common-components';
import {MessageService} from "../services/message-service";
import {HttpClient} from "@angular/common/http";

let _ : any = require("lodash");

@Component({
    selector: 'dk-static-content',
    template: require('./static-content.html'),
    entryComponents: [],
    providers: []
})

export class StaticContentComponent extends BaseComponent implements OnInit {
    page: string;
    pageContent: string;

    constructor(private route: ActivatedRoute, private http: HttpClient) {
        super();
        this.page = route.snapshot.url[1].path;
    }

    public ngOnInit() {
        this.http.get('/' + this.page + '?content=1', { responseType: "text" }).subscribe((result) => {
            this.pageContent = result;
        });
    }
}
